export class OneTrustModule {
    // There could be more categories in the future coming from OneTrust
    COOKIE_CATEGORIES = {
        STRICTLY_NECESSARY: 'C0001',
        PERFORMANCE: 'C0002', // MixPanl is under the performance cookies category
        FUNCTIONAL: 'C0003',
        TARGETING: 'C0004'
    }

    isOneTrustIsInitialized() {
        return window.OptanonActiveGroups !== undefined 
    }

    elementIsAllowedToDisplay(cookieCategoryID) {
        if (typeof window.OptanonActiveGroups == 'undefined') {
            return false
        }

        const template = ',' + cookieCategoryID + ','
        return window.OptanonActiveGroups.includes(template)
    }

    arePerformanceCookiesAccepted() {
        return this.elementIsAllowedToDisplay(this.COOKIE_CATEGORIES.PERFORMANCE)
    }
}

const OneTrust = new OneTrustModule()
export default OneTrust